import type { JSX } from 'react';
import { useEffect } from 'react';
import type { LumbarRadiculopathyReferralData } from '@common/validation/customControls/neurology/lumbarRadiculopathy/lumbarRadiculopathyReferral/lumbarRadiculopathyReferral';
import type { InputComponentsMap } from '@frontend/formEngine/editForm/editForm.types';
import { lumbarRadiculopathyReferralSections } from '@common/validation/customControls/neurology/lumbarRadiculopathy/lumbarRadiculopathyReferral/lumbarRadiculopathyReferral';
import { EditForm } from '@frontend/formEngine/editForm/EditForm';
import { useProcessActivityEditContext } from '@frontend/utils';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';
import { ExclusiecriteriaGelezen } from './ExclusiecriteriaGelezen';
import { ToestemmingPatient } from './ToestemmingPatient';

export function LumbarRadiculopathyReferralEdit(): JSX.Element {
    const { data, onChange, processActivityId } = useProcessActivityEditContext<LumbarRadiculopathyReferralData>();
    const { patient } = usePatientEpisodeCategoryContext();

    // TODO: CS-23832 Make this generic
    useEffect(() => {
        if (!processActivityId && patient.emailAddress) {
            onChange({
                patient: {
                    emailAddress: data.patient.emailAddress ?? patient.emailAddress ?? null,
                },
            });
        }
    }, [processActivityId, patient.emailAddress]);

    return (
        <EditForm
            inputComponents={getInputComponents()}
            sections={lumbarRadiculopathyReferralSections}
        />
    );

    function getInputComponents(): InputComponentsMap<keyof LumbarRadiculopathyReferralData> {
        const map: InputComponentsMap<keyof LumbarRadiculopathyReferralData> = new Map();
        map.set('exclusiecriteria_gelezen', <ExclusiecriteriaGelezen />);
        map.set('toestemming_patient_voor_benaderen_feedback', <ToestemmingPatient />);

        return map;
    }
}
